export const COACH_COLORS = [
  { name: "Tradestats", top: "#FF4701", bottom: "#FF9003", accent: "#ff6500" },
  { name: "Neon Green", top: "#95FF01", bottom: "#03FFB8", accent: "#70ff54" },
  {
    name: "Electric Violet",
    top: "#013CFF",
    bottom: "#FB03FF",
    accent: "#b35aff",
  },
  {
    name: "Candy Sunset",
    top: "#FF00FF",
    bottom: "#FCCF3A",
    accent: "#ff63c6",
  },
  { name: "Ocean Pulse", top: "#70FF40", bottom: "#0040FF", accent: "#58dba4" },
  {
    name: "Cosmic Purple",
    top: "#FF0A6C",
    bottom: "#0040FF",
    accent: "#dc58d7",
  },
  { name: "Aurora Mint", top: "#FFE53B", bottom: "#00FFFF", accent: "#70f4ce" },
] as const;
